export class UnsupportedError extends Error {
}
